import type { ReactNode } from 'react';

import { Link } from 'react-router';

import type { SidebarItem } from './types';

export function getSidebarItem(label: ReactNode, key: string, icon?: ReactNode, children?: SidebarItem[]): SidebarItem {
  const finalLabel = children ? label : <Link to={key}>{label}</Link>;

  return {
    key: `/${key}`,
    icon,
    children,
    label: finalLabel,
  } as SidebarItem;
}
